<template>
    <v-container fluid pa-0 ma-0 style="max-height: 90px;" v-if="totalMinutesRemaining">
        <v-row justify="end" align="center">
            <v-col cols="auto">
                <span class="body-2">{{$t('general.eta')}}: <b>{{ hours }}{{$t('general.hour_abbrev')}} {{ minutes }}{{$t('general.minute_abbrev')}}</b></span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "TimeRemaining",
      //TODO: Finish the formatting
      computed:{
          totalMinutesRemaining(){
            return this.$store.getters['assessment/minutesRemaining'];
          },
          hours(){
            return Math.floor(this.totalMinutesRemaining / 60);
          },
          minutes(){
            return this.totalMinutesRemaining % 60;
          }
      }
    }
</script>

<style scoped>

</style>